import {DisplayFeature} from "../domain";
import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import {
    DeSelectAllFeatures,
    deselectAllFeatures,
    SetSelectFeatures,
    setSelectFeatures
} from "../../../actions/actions";
import FeaturesState from "../domain/FeaturesState";


interface ComponentState {
}

interface ComponentProps {
    selectedFeatures?: Array<DisplayFeature>;
    doDeselectAllFeatures?: DeSelectAllFeatures;
    doSelectFeatures?: SetSelectFeatures;
    featuresInView?: Array<DisplayFeature>;
}

const mapStateToProps = (state: FeaturesState) => {
    return {
        selectedFeatures: selectors.selectedFeatures(state),
        featuresInView: selectors.features(state),
    };
};

const mapDispatchToProps = ({
    doDeselectAllFeatures: deselectAllFeatures,
    doSelectFeatures: setSelectFeatures
});


class MultipleFeatureSelectorComponent extends React.Component<ComponentProps, ComponentState> {
    render() {
        let {selectedFeatures} = this.props;
        const style = selectedFeatures.length === 0 ? "select-all-button" : "select-all-button deselect-all";
        const title = selectedFeatures.length === 0 ? "Velg alle" : "Velg ingen";
        return (
            <button className={style} title={title} onClick={(e) => this.handleClick(e)}>
                <i className="fas fa-check" />
            </button>
        );
    }

    handleClick(event: React.MouseEvent<HTMLSpanElement>) {
        event.stopPropagation();
        let {selectedFeatures, doDeselectAllFeatures, doSelectFeatures, featuresInView} = this.props;
        if (selectedFeatures.length > 0) {
            doDeselectAllFeatures();
        } else {
            let allFeatureIds = featuresInView.map(feature => feature.id);
            doSelectFeatures(allFeatureIds);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleFeatureSelectorComponent);